import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { WorkspaceFacade } from '../workspace';
import { WorkflowSectionStatus } from './workflow.models';
import { WorkflowActions } from './workflow.actions';
import {
  selectWorkflowDbDesignSummary,
  selectWorkflowDefineDoc,
  selectWorkflowDefineSummary,
  selectWorkflowIssues,
  selectWorkflowStatuses,
  selectWorkflowTicketsSummary,
} from './workflow.selectors';

@Injectable({ providedIn: 'root' })
export class WorkflowFacade {
  private store = inject(Store);
  private workspace = inject(WorkspaceFacade);

  readonly activeProjectId = this.workspace.activeProjectId;
  readonly defineDoc = toSignal(this.store.select(selectWorkflowDefineDoc), { initialValue: null });
  readonly defineSummary = toSignal(this.store.select(selectWorkflowDefineSummary), { requireSync: true });
  readonly dbDesignSummary = toSignal(this.store.select(selectWorkflowDbDesignSummary), { requireSync: true });
  readonly ticketsSummary = toSignal(this.store.select(selectWorkflowTicketsSummary), { requireSync: true });
  readonly statuses = toSignal(this.store.select(selectWorkflowStatuses), { initialValue: [] as WorkflowSectionStatus[] });
  readonly issues = toSignal(this.store.select(selectWorkflowIssues), { initialValue: [] as string[] });

  warmProject(projectId: string): void {
    this.store.dispatch(WorkflowActions.warmProject({ projectId }));
  }
}
